import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useSnackbarStore } from '../../../shared/stores/snackbarStore';

export const orgAutoSubmitKeys = {
  all: ['organisation', 'auto-submit'] as const,
  overview: () => [...orgAutoSubmitKeys.all, 'overview'] as const,
};

export function useOrgAutoSubmitOverview() {
  return useQuery({
    queryKey: orgAutoSubmitKeys.overview(),
    queryFn: async ({ signal }) =>
      unwrap(
        await api.portalGateway.GET('/portal/v1/automatic-submission', {
          signal,
        })
      ),
  });
}

export function useSetOrgAutoSubmit() {
  const queryClient = useQueryClient();
  const showSnackbar = useSnackbarStore(state => state.showSnackbar);

  return useMutation({
    mutationFn: async (isEnabled: boolean) =>
      unwrap(
        await api.portalGateway.PUT('/portal/v1/automatic-submission', {
          body: { isEnabled },
        })
      ),
    onSuccess: (data, isEnabled) => {
      queryClient.setQueryData(orgAutoSubmitKeys.overview(), data);
      showSnackbar(
        isEnabled
          ? 'Auto-submit turned on — applies from each new pot'
          : 'Auto-submit turned off — applies from each new pot',
        'success'
      );
    },
  });
}
